<div class="ui modal" id="ReadPayoutSlip" style="position:absolute;left:40%;bottom:15%; width:500px !important;">

    <div class="header" style="display:flex;">
        <div style="background-color:black;width:85%;color:white;"><span style="margin-left:10px">ReadPayout</span></div>
        <div style="background-color:black;width:15%;margin-left:10px">
            <button style="float:right;background-color:black;color:white;width:100%" class="ui icon button" (click)="ReadPayoutSlip_Close()">
                <i class="remove link icon"></i>
            </button>
        </div>
    </div>

    <div class="content">
        <div class="ui fluid input">
            <input placeholder="Ticket Number" style="text-align:right;height:55px;font-size:15px;background-color:gainsboro;width:60% !important" type="text" [(ngModel)]="this.tournamentsService.PayoutSlipNumber"   value="{{this.tournamentsService.PayoutSlipNumber}}" (focus)="ReadPayoutSlip_TicketNumber()">


            <input placeholder="Ticket Password" style="text-align:right;height:55px;font-size:15px;background-color:gainsboro;width:35% !important;margin-left:25px" type="text" [(ngModel)]="this.tournamentsService.PayoutSlipPassword"   (focus)="ReadPayoutSlip_TicketPassword()">
        </div>
    </div>
    <div *ngIf="this.tournamentsService.readPayoutErrorVisible==1"  class="inline field" style="text-align: center;color:red;">


        <span>{{this.tournamentsService.readPayoutError}}</span>

    </div>
    <div class="content">
        <div class="ui grid segment" style="height:412px;background-color:gainsboro;">
            <table class="ui table" id="ReadPayoutSlip_Modal_ButtonTable" style="background-color:gainsboro;">
                <tr>
                    <td class="four wide">
                        <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(1)">1</button>
                    </td>
                    <td class="four wide">
                        <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(2)">2</button>
                    </td>
                    <td class="four wide">
                        <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue('3')">3</button>
                    </td>
                    <td rowspan="2" class="four wide">
                        <button class="ui fluid icon button" style="height:170px;width:70px;background:black;color:white;" (click)="ReadPayoutSlip__Cancel()">
                            <i class="big arrow left icon"></i>
                        </button>
                    </td>
                </tr>
                <tr>
                    <td class="four wide">
                        <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(4)">4</button>
                    </td>
                    <td class="four wide">
                        <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(5)">5</button>
                    </td>
                    <td class="four wide">
                        <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(6)">6</button>
                    </td>
                </tr>
                <tr>
                    <td class="four wide">
                        <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(7)">7</button>
                    </td>
                    <td class="four wide">
                        <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(8)">8</button>
                    </td>
                    <td class="four wide">
                        <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(9)">9</button>
                    </td>
                    <td rowspan="2" class="four wide">
                        <button class="ui fluid button" style="height:170px;width:70px;background:black;color:white;" (click)="ReadPayoutSlipOk()">
                            OK
                        </button>
                    </td>
                </tr>
                <tr style="height:102px">
                    <td></td>


                </tr>

            </table>
            <button class="SettingLoginButton" style="color:white;width:296px; height: 71px;position:relative;bottom: 103px;margin-left:25px;" (click)="ReadPayoutSlip_ChangeValue(0)">
                0
            </button>
        </div>
    </div>

</div>
<div class="ui modal" id="PayoutDetailModal" style="width:450px; font-family:'Arial Narrow'">
    <div class="checkpanel" style="width: 95%; margin-left:14px;height:180px;background-color:aliceblue;">

        <div>
            <form>

                <div style="min-height:20px;margin-top:18px;background-color:white">
                    <div style="text-align:center;font-size:18px">
                        <span> {{"PayoutSlip" | t}}</span>
                    </div>

                </div>
                <!--Period-->
                <div style="margin-top:18px">
                    <div *ngIf="this.tournamentsService.payoutModalList[0]?.IsPaid==false">
                        <div style="min-height:20px;">
                            <div class="payout_Window_Item">
                                <span style="font-weight:bold">{{"PaidStatus" | t}}:</span><span> {{this.tournamentsService.payoutModalList[0]?.IsPaid}}</span>
                            </div>

                        </div>
                        <div style="min-height:20px;">
                            <div class="payout_Window_Item">
                                <span style="font-weight:bold">{{"Amount" | t}}:</span><span>{{this.tournamentsService.payoutModalList[0]?.Amount}}</span>
                            </div>

                        </div>
                    </div>
                    <div *ngIf="this.tournamentsService.payoutModalList[0]?.IsPaid==true">

                        <div style="min-height:20px;">
                            <div class="payout_Window_Item">
                                <span style="font-weight:bold">{{"PaidStatus" | t}}:</span><span>{{this.tournamentsService.payoutModalList[0]?.IsPaid}}</span>
                            </div>

                        </div>
                        <div style="min-height:20px;">
                            <div class="payout_Window_Item">
                                <span style="font-weight:bold">{{"Amount" | t}}:</span><span>{{this.tournamentsService.payoutModalList[0]?.Amount}}</span>
                            </div>

                        </div>
                        <div style="min-height:20px;">
                            <div class="payout_Window_Item">
                                <span style="font-weight:bold">{{"UpdateDate" | t}}:</span><span>{{this.tournamentsService.payoutModalList[0]?.UpdateDate}}</span>
                            </div>

                        </div>
                        <div style="min-height:20px;">
                            <div class="payout_Window_Item">
                                <span style="font-weight:bold">{{"UpdateUserName" | t}}:</span><span>{{this.tournamentsService.payoutModalList[0]?.UpdateUserName}}</span>
                            </div>

                        </div>
                    </div>
                </div>

            </form>


        </div>

    </div>
    <div *ngIf="this.tournamentsService.PayoutPayConfirmVisible==1"  class="ui positive message" style="padding:6px;font-size:17px">
        <i class="checkmark icon"></i>
        <span>{{this.tournamentsService.PayoutPayConfirm}}</span>
    </div>
    <div style="text-align:center;height:65px">


        <button class="ui big button terminalButton"     *ngIf="this.tournamentsService.payoutModalList[0]?.IsPaid==false" style="width:155px;margin-top: 10px;background-color:aliceblue" id="Payout_Pay_Id" (click)="Payout_Detail_Pay(this.tournamentsService.payoutModalList[0]?.CurrencyId,this.tournamentsService.payoutModalList[0]?.Amount,this.tournamentsService.payoutModalList[0]?.BranchTransactionId)">
        <span>{{"PayoutSlipPay" | t}}</span>
        </button>

        <button  class="ui big button terminalButton"    style="width:155px;margin-top:10px;background-color:aliceblue" id="Pay_Window_Detail_Exit_Id" (click)="PayoutDetailModal_Exit()">
         <span>{{"Exit" | t}}</span>
        </button>
    </div>

</div>
